
const AccessMap = () => {
  return (
    <section className="pb-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="bg-white rounded-2xl shadow-[0_4px_24px_rgba(137,181,107,0.08)] overflow-hidden">
          <div className="p-6">
            <div className="w-full h-[400px] rounded-xl overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d202.7013908036659!2d139.7211884824648!3d35.6222470477399!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188ae557060979%3A0x140c983467c6c01a!2z44CSMTQxLTAwMzEg5p2x5Lqs6YO95ZOB5bed5Yy66KW_5LqU5Y-N55Sw77yY5LiB55uu77yX4oiS77yR77yRIOOCouOCr-OCt-OCueS6lOWPjeeUsOODk-ODqw!5e0!3m2!1sja!2sjp!4v1751431605653!5m2!1sja!2sjp"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="株式会社MSK アクセスマップ"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AccessMap;
